import { transformPromptDtoToCard } from '../../../utils/transformPromptDtotoCard';

import { SearchResponse, SearchResponseDto } from './types';

export const transformPromptsDtoToCards = (response: SearchResponseDto): SearchResponse => {
    return response.map(transformPromptDtoToCard);
};
